import { useState, useEffect } from "react";

/**
 * Returns a boolean that is true after the first render. Primarily used for hiding
 * elements that will only be rendered on the client.
 *
 * This is useful if it's too difficult to render server-side, and is not necessary
 * to render initially, e.g. a Footer element at the bottom of the page.
 */
const useHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};

export default useHasMounted;
